import { useUsers } from "@common/api/users"
import type { FilterFieldConfig } from "@common/components/filters/filter-config"
import { PenLine, UserRound } from "lucide-react"
import type { TechLogFilterValues } from "./tech-log"

export function usePeopleOptions() {
  const { users, isLoading } = useUsers()
  return {
    options: users.map((user) => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name}`.trim(),
    })),
    isLoading,
  }
}

export const techLogFilterConfigs: FilterFieldConfig<TechLogFilterValues>[] = [
  {
    key: "log_entered_by",
    label: "Entered by",
    icon: UserRound,
    type: "multiselect",
    searchPlaceholder: "Search people",
    emptyLabel: "No people",
    useOptions: usePeopleOptions,
    get: (values) => values.log_entered_by,
    set: (next) => ({ log_entered_by: next?.map(String) }),
  },
  {
    key: "log_updated_by",
    label: "Last updated by",
    icon: PenLine,
    type: "multiselect",
    searchPlaceholder: "Search people",
    emptyLabel: "No people",
    useOptions: usePeopleOptions,
    get: (values) => values.log_updated_by,
    set: (next) => ({ log_updated_by: next?.map(String) }),
  },
]
